import React, { useState } from 'react';
import { Button, Card, Input, InputAddress, Select, Text } from 'v3/components';
import { usePreLoad } from '../context';
import { Col, Row } from 'react-bootstrap';
import { DELIVERY_TYPE_OPTIONS } from 'v3/utils/constants';
import IconButton from 'v3/components/Button/Icon';
import { validateDateTime } from 'v3/utils/functions';
import { StyledDestinationNavButton } from '../styles';
import { fetchByCityAndProvince } from 'utils/fetches';

export function DestinationsData() {
  const {
    data,
    setData,
    errors,
    countryOptions,
    destinationsError,
    setErrors,
    loading,
    loadingDuplicate,
  } = usePreLoad();

  const [currentIndex, setCurrentIndex] = useState(0);

  function handleChangeValue(index, key, value) {
    setData((old) => ({
      ...old,
      destinations: old?.destinations?.map((item, idx) => {
        if (index === idx) {
          return { ...item, [key]: value };
        }

        return item;
      }),
    }));
  }

  function handleDeleteCard(idx) {
    setData((old) => ({
      ...old,
      destinations: old?.destinations?.filter((_, index) => index !== idx),
    }));
    setCurrentIndex(idx - 1);
  }

  async function setDestinationCity(index, city) {
    let cityModel = city;
    if (cityModel) {
      handleChangeValue(index, 'cityModel', cityModel);
      handleChangeValue(index, 'province', cityModel?.province?.uf || '');
      handleChangeValue(index, 'lat', cityModel?.lat);
      handleChangeValue(index, 'lng', cityModel?.lng);
    } else {
      handleChangeValue(index, 'cityModel', null);
      handleChangeValue(index, 'province', '');
      handleChangeValue(index, 'lat', null);
      handleChangeValue(index, 'lng', null);
    }
  }
  function handleGoBack(idx) {
    if (idx < 1) {
      return;
    }
    setCurrentIndex(idx - 1);
  }
  function handleGoToNext(idx) {
    if (idx + 1 > data?.destinations?.length) {
      return;
    }
    setCurrentIndex(idx + 1);
  }
  function handleAddNewDestination() {
    setCurrentIndex(data?.destinations?.length);
    setData((old) => ({
      ...old,
      destinations: [
        ...old?.destinations,
        {
          address: '',
          type: DELIVERY_TYPE_OPTIONS[1],
          date: '',
          lat: null,
          lng: null,
          city: '',
          cityModel: null,
          province: '',
          country: {
            id: 1,
            name: 'Brasil',
            abbreviation: 'br',
            ddi: 55,
          },
          startSchedule: '',
          index: data?.destinations?.length + 1,
        },
      ],
    }));
  }
  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Destinos
        </Text>
      }
      bodyCardPadding="1rem 3rem"
    >
      <Col md={12} xs={12}>
        <div className="mb-2">
          <Text type="header" color="dark">
            Destino {currentIndex + 1}
          </Text>
        </div>
        <Row>
          <Col md={12} xs={12} className="m-0" >
            <Col md={4} xs={12} className="m-0 p-1">
              <Select
                label="País *"
                value={data?.destinations[currentIndex]?.country}
                options={countryOptions}
                onChange={event => {
                  handleChangeValue(currentIndex, 'country', event);
                  handleChangeValue(currentIndex, 'cityModel', null);
                  handleChangeValue(currentIndex, 'province', '');
                  handleChangeValue(currentIndex, 'lat', null);
                  handleChangeValue(currentIndex, 'lng', null);
                }}
                getOptionLabel={option => option.name}
                getOptionValue={option => option.id}
                isDisabled={loading || loadingDuplicate}
                error={errors[`destinations[${currentIndex}].country`]}
              />
            </Col>
          </Col>

          <Col md={6} xs={12} className="mb-3">
            <InputAddress
              label="Cidade *"
              typesRestriction={['(cities)']}
              value={data?.destinations[currentIndex]?.cityModel?.name || ''}
              country={data?.destinations[currentIndex]?.country?.abbreviation}
              onSelectedAddress={async place => {
                const [city] = await fetchByCityAndProvince(
                  place.city,
                  place.province
                );
                setDestinationCity(
                  currentIndex,
                  {
                    id: city?.id,
                    lat: place?.lat,
                    lng: place?.lng,
                    name: city?.name || place?.name,
                    province: city?.province || place?.province,
                  });
              }}
              error={errors[`destinations[${currentIndex}].cityModel`]}
            />
          </Col>
          <Col md={4} xs={12} className="mb-3">
            <Input
              label="UF *"
              disabled={true}
              value={data?.destinations[currentIndex]?.province}
              onChange={({ target }) => {
                handleChangeValue(currentIndex, 'province', target.value);
              }}
              error={errors[`destinations[${currentIndex}].province`]}
            />
          </Col>
          <Col md={4} xs={12} className="mb-3">
            <Input
              type="datetime-local"
              value={data?.destinations[currentIndex]?.startSchedule}
              label="Data Inicial *"
              disabled={loading || loadingDuplicate}
              onChange={({ target }) => {
                const isValid = validateDateTime(target?.value);
                if (isValid) {
                  handleChangeValue(currentIndex, 'startSchedule', target.value);
                  setErrors((old) => ({
                    ...old,
                    [`destinations[${currentIndex}].startSchedule`]: null,
                  }));
                } else {
                  handleChangeValue(currentIndex, 'startSchedule', target.value);
                  setErrors((old) => ({
                    ...old,
                    [`destinations[${currentIndex}].startSchedule`]: 'Data inválida',
                  }));
                }
              }}
              error={
                errors[`destinations[${currentIndex}].startSchedule`] ||
                errors[`destinations[${currentIndex}]`] ||
                destinationsError[`${currentIndex}.startSchedule`]
              }
            />
          </Col>
          <Col md={4} xs={12} className="mb-3">
            <Input
              type="datetime-local"
              label="Data Final *"
              value={data?.destinations[currentIndex]?.date}
              disabled={loading || loadingDuplicate}
              onChange={({ target }) => {
                const isValid = validateDateTime(target?.value);
                if (isValid) {
                  handleChangeValue(currentIndex, 'date', target.value);
                  setErrors((old) => ({
                    ...old,
                    [`destinations[${currentIndex}].date`]: null,
                  }));
                } else {
                  handleChangeValue(currentIndex, 'date', target.value);
                  setErrors((old) => ({
                    ...old,
                    [`destinations[${currentIndex}].date`]: 'Data inválida',
                  }));
                }
              }}
              error={
                errors[`destinations[${currentIndex}].date`] ||
                destinationsError[`${currentIndex}.date`]
              }
            />
          </Col>

          <Col md={4} xs={12}>
            <Select
              label="Ação *"
              value={data?.destinations[currentIndex]?.type}
              onChange={value => {
                handleChangeValue(currentIndex, 'type', value);
              }}
              getOptionLabel={(option) => option?.name}
              getOptionValue={(option) => option?.id}
              options={DELIVERY_TYPE_OPTIONS}
              error={errors[`destinations[${currentIndex}].type`]}
              isDisabled={loading || loadingDuplicate}
            />
          </Col>
          <Col md={6} xs={12} className="mt-4">
            <IconButton
              title="Remover destino"
              style={{ marginTop: 12 }}
              icon="FaTrash"
              variant="error"
              disabled={currentIndex === 0 || loading || loadingDuplicate}
              onClick={() => handleDeleteCard(currentIndex)}
            />
          </Col>
        </Row>
      </Col>

      <Row className="form" style={{ justifyContent: 'end' }}>
        <Col
          md={6}
          xs={12}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            justifyContent: 'end',
          }}
        >
          <StyledDestinationNavButton
            variant={'secondary'}
            disabled={currentIndex < 1 || loading || loadingDuplicate}
            title="Destino anterior"
            onClick={() => handleGoBack(currentIndex)}
          >
            <Text>{'<'}</Text>
          </StyledDestinationNavButton>
          <StyledDestinationNavButton
            variant="secondary"
            title="Próximo destino"
            disabled={data?.destinations?.length === currentIndex + 1 || loading || loadingDuplicate}
            onClick={() => handleGoToNext(currentIndex)}
          >
            <Text>{'>'}</Text>
          </StyledDestinationNavButton>
          <Button onClick={() => handleAddNewDestination()} disabled={loading || loadingDuplicate}>
            <Text weight={500} type="regular">
              Adicionar mais 1 destino
            </Text>
          </Button>
        </Col>
      </Row>
    </Card>
  );
}
